module.exports = __webpack_public_path__ + "img/C.5be9bde4.svg";